// window.onload = function() {
//     console.log("here");
// };

document.addEventListener("scroll", function() {
    const container = document.querySelector('.section-spacing .container');
    const containerPosition = container.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    // Check if the container is within 100px of the viewport
    if (containerPosition < windowHeight - 200) {
        container.classList.add('expanded');
    } else {
        container.classList.remove('expanded');
    }
});

document.addEventListener("scroll", function() {
    const newscontainer = document.querySelector('.shopify-section--newsletter div .newsletter');
    let newscontainerPosition = 0;
    const windowHeight = window.innerHeight;

    if (newscontainer) {
        newscontainerPosition = newscontainer.getBoundingClientRect().top;

        // Check if the container is within 200px of the viewport
        if (newscontainerPosition < windowHeight - 200) {
            newscontainer.classList.add('expanded');
        } else {
            newscontainer.classList.remove('expanded');
        }
    }
});
